(function (window, document, undefined) {
  "use strict";

  let Vue = window.Vue || false,
    logger;

  const init = function () {
    try {
      logger = new window.RussMedia.Utils.Logger("[topic page index] ") || {
        log: function () {},
      };
    } catch (e) {
      logger = { log: function () {} };
    }

    if (!Vue) {
      logger.log("_init: No Vue!");
      return;
    } else {
      logger.log("Load Vue component.");
    }

    let parsedTopicListData = parseTopicListData();
    if (!parsedTopicListData) {
      logger.log("init: No topic list data.");
      return;
    }

    renderTopicIndex(parsedTopicListData);
  };

  const parseTopicListData = function () {
    const topicListDataNode = document.querySelector("#topicListDataNode");

    let parsedTopicListData = {};

    try {
      parsedTopicListData = JSON.parse(topicListDataNode.innerHTML) || false;
    } catch (e) {
      return false;
    }

    return parsedTopicListData;
  };

  const renderTopicIndex = (topicListData) => {
    Vue.createApp({
      components: {
        TopicIndexPage: window["@russmedia-frontend/np-topics"].TopicIndexPage,
      },
      setup() {
        return {
          paginationUrlConfig: topicListData.paginationUrlConfig,
          hitsPage: topicListData.hitsPage,
          hitsPerPage: topicListData.hitsPerPage,
          prefetchedRawData: topicListData.prefetchedRawData,
        };
      },
      template: `<TopicIndexPage :pagination-url-config="paginationUrlConfig" :hits-page="hitsPage" :hits-per-page="hitsPerPage" :prefetched-raw-data="prefetchedRawData"></TopicIndexPage>`,
    }).mount("#vodl-page-topic-index");
  };

  init();
})(window, document);
